<template>
    <v-container fluid class="mt-5 pl-14 pr-14">
        <img src="@/assets/logo-big.svg" alt="Luzern" />
    </v-container>
</template>
<script setup lang="ts"></script>
